import { useEffect, useState } from "react";
import { Row, Col } from "react-grid-system";
import { v4 as uuidv4 } from "uuid";
import styled from "styled-components";

import { IoIosArrowBack } from "react-icons/io";

import { StyledColor, ItemsMenu } from "../../../interface/index";
import colors from "../../../assets/colors/colors";

import toast, { Toaster } from "react-hot-toast";
import Loader from "../../utils/Loader";
import MyDropzone from "./DropZone";
import ListItems from "./ListItems";

import { getDatabase, ref, update, set } from "firebase/database";

import { uploadFile } from "../../../firebase-config";

interface Props {
  closeModal: () => void;
  data: any;
}

export default function ModalItems(props: Props) {
  const [items, setItems] = useState<any>([]);

  const [openCreate, setOpenCreate] = useState<boolean>(false);

  // form create
  const [form_create, setFormCreate] = useState<any>({
    name: "",
    description: "",
    price: "",
    image: "",
  });

  const [isLoader, setLoader] = useState<boolean>(false);

  const [complete, setComplete] = useState<any>(false);
  const [newimage, setNewImage] = useState<any>(false);
  const [edit, setEdit] = useState<any>(false);

  useEffect(() => {
    // setItems(props.data.items)
    getItems();
  }, []);

  const handleEdit = (dt: ItemsMenu) => {
    setOpenCreate(true);
    setEdit(true);

    setFormCreate({
      name: dt.name,
      description: dt.description,
      price: dt.price,
      image: dt.image,
      id: dt.id,
      position: dt.position - 1,
    });
  };

  const getItems = async () => {
    setLoader(true);
    setItems([]);

    try {
      let arrayItems: any = [];

      const items = props.data.items;
      Object.entries(items).forEach(([key, value]: any) => {
        if (value !== undefined) {
          arrayItems.push(value);
        }
      });
      setItems(arrayItems);
      setLoader(false);
    } catch (error) {
      //   toast.error("Ha ocurrido un error al traer los items");
      setLoader(false);
    }
  };

  const onChange = (e: any) => {
    const value = e.target.value;
    const index = e.target.id;
    form_create[index] = value;
    setFormCreate({
      ...form_create,
    });
  };

  const closeFullScreen = () => {
    props.closeModal();
  };

  const handleAddItem = () => {
    setOpenCreate(true);
    setEdit(false);
  };

  const handleCreate = async () => {
    const db = getDatabase();

    if (edit)
      if (form_create.name === "" || form_create.price === "") {
        toast.error("Campos requeridos: Nombre, Descripcion y precio.👆");
        return;
      }
    const id_restaurant = props.data.id_restaurant;
    const id_section = props.data.id;

    const uuidNew = uuidv4();

    const newData = {
      ...form_create,
      id_restaurant,
      id_section,
      image: newimage || form_create.image,
    };

    try {
      // create item
      const createItem = { ...newData, id: uuidNew };

      //create
      if (!edit) {
        const id_restaurant = createItem.id_restaurant;
        const id_section = createItem.id_section;
        const idNew = createItem.id;

        const dbDirection = `/restaurants/${id_restaurant}/menu/${id_section}/items/${idNew}`;
        set(ref(db, dbDirection), createItem);

        toast.success("Articulo agregado exitosamente.🤩");
        setFormCreate({
          name: "",
          description: "",
          price: "",
          image: "",
        });
        getItems();
      }
      // edit item
      else {
        editItem(newData);
      }

      // setOpenCreate(false)
    } catch (error) {
      toast.error("No se pudo crear el item.😬");
    }
  };

  const editItem = (newData: any) => {
    const db = getDatabase();
    const id_restaurant = newData.id_restaurant;
    const id_section = newData.id_section;

    items[newData.position] = newData;

    const list: any = [...items];
    let new_list = [];

    list.map((lt: any, index: any) => {
      let object = { ...lt, position: index };
      new_list.push(object);
    });

    try {
      const dbDirection = `/restaurants/${id_restaurant}/menu/${id_section}/items/`;
      const updates: any = {};
      updates[dbDirection] = list;

      update(ref(db), updates);

      toast.success("Posiciones de las items modificadas correctamente.");
      setLoader(false);
    } catch (error) {
      toast.error("Error al editar los items.😬");
      setLoader(false);
    }
  };

  const handlePostImage = async (files: any) => {
    try {
      let form_data = new FormData();
      if (files[0]) {
        form_data.append("file", files[0]);
      } else {
        return null;
      }
      const uuidNew = uuidv4();

      const result = await uploadFile(files[0], uuidNew);

      setNewImage(result);

      setLoader(false);
      setComplete(true);
    } catch (error) {
      toast.error("Ha ocurrido un error al subir la imagen.😬");
      setComplete(false);
    }
  };

  const handleDelete = async (dt: ItemsMenu) => {
    const db = getDatabase();
    const id_restaurant = props.data.id_restaurant;
    const id_section = props.data.id;

    const object = {
      id: dt.id,
      id_restaurant,
      id_section,
    };

    if (!id_restaurant || !id_section) {
      toast.error("Ha ocurrido un error😬");
      return;
    }

    try {
      const updates: any = {};
      updates[
        "/restaurants/" +
          object.id_restaurant +
          "/menu/" +
          object.id_section +
          "/items/" +
          object.id
      ] = null;

      setLoader(false);
      toast.success("Articulo eliminado correctamente.😬");
      return update(ref(db), updates);
    } catch (error) {
      toast.error("No se pudo eliminar el Articulo.😬");
    }
  };

  return (
    <Content color={colors}>
      <header>
        <Row align="center">
          <Col xs={2}>
            <button
              onClick={() =>
                openCreate ? setOpenCreate(false) : closeFullScreen()
              }
            >
              <IoIosArrowBack />
            </button>
          </Col>
          <Col>
            <h2 className="px-2 pt-1">{props.data.name}</h2>
          </Col>
        </Row>
      </header>
      <div className="main">
        {isLoader && (
          <div className="w-100 text-center">
            <Loader color="#3498db" />
          </div>
        )}
        {!openCreate && (
          <button
            className="btn btn-primary w-100 mt-4 mb-5"
            onClick={() => handleAddItem()}
          >
            Agregar item
          </button>
        )}
        {!openCreate && (
          <ul>
            {items && (
              <>
                <ListItems
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  items={items}
                  data={props.data}
                />
              </>
            )}
          </ul>
        )}
        {items.length === 0 && (
          <>
            <h4>0 articulos...</h4>
          </>
        )}

        {openCreate && (
          <div className="editProduct">
            <div className="form">
              <div>
                <label>Nombre *</label>
                <input
                  type="text"
                  placeholder=""
                  className="form-control shadow-none"
                  id="name"
                  value={form_create.name}
                  onChange={onChange}
                />
              </div>
              <div>
                <label>Descripción *</label>
                <textarea
                  // type="text"
                  placeholder=""
                  className="form-control shadow-none"
                  id="description"
                  value={form_create.description}
                  onChange={onChange}
                ></textarea>
              </div>
              <div>
                <label>Precio *</label>
                <input
                  type="text"
                  placeholder=""
                  className="form-control shadow-none"
                  id="price"
                  value={form_create.price}
                  onChange={onChange}
                  style={{ width: "40%" }}
                />
              </div>
              <div>
                <label>Imagen *</label>
                {!isLoader && (
                  <MyDropzone
                    postImage={handlePostImage}
                    image={form_create.image}
                    new_image={newimage}
                    complete={complete}
                  />
                )}
                <input
                  type="text"
                  placeholder="url image"
                  className="form-control shadow-none"
                  id="image"
                  value={form_create.image}
                  onChange={onChange}
                />
              </div>
            </div>

            {!isLoader && (
              <div className="w-100 my-4 text-center">
                <div className="row align-items-center justify-content-center">
                  <div className="col-4" onClick={() => setOpenCreate(false)}>
                    <button className="btn btn-secondary d-block w-100">
                      Cancelar
                    </button>
                  </div>
                  <div className="col-4">
                    <button
                      className="btn btn-success d-block w-100"
                      onClick={() => handleCreate()}
                    >
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <Toaster position="bottom-center" reverseOrder={false} />
    </Content>
  );
}

const Content = styled.div<StyledColor>`
  width: 100%;
  height: 100vh;
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20000;
  overflow: scroll;
  padding-bottom: 10em;
  header {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 10000;
    padding: 1em 0;
    background: white;
    border-bottom: 1px solid #ecf0f1;
    color: #2c3e50;
    button {
      border: none;
      background: white;
      padding: 0.8em 1em;
      box-shadow: 0px 0px 10px #0000012f;
      border-radius: 6px;
      color: #2c3e50;
      svg {
        font-size: 1.5em;
        margin-top: -5px;
      }
    }
  }
  .main {
    width: 100%;
    min-height: 10vh;
    padding: 1em;
    margin-top: 5em;
    overflow: scroll;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    li {
      position: relative;
      padding: 1em 0;
      border-bottom: 1px solid ${(props) => props.color.citylight};
      img {
        width: 100%;
      }
    }
    p,
    h6 {
      margin: 0 !important;
    }
    .edit {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  label {
    margin: 0;
    font-size: 1em;
    font-weight: 500;
  }
  .form div {
    padding: 0.5em 0;
    img {
      display: block;
      width: 150px;
    }
  }
  input[type="file"] {
    display: block;
  }
  input,
  textarea {
    display: block;
    font-size: 1em;
    border: 2px solid ${(props) => props.color.white01};
    &:focus {
      border: 2px solid ${(props) => props.color.blue};
    }
  }
`;
